import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { publicHash } from '../../utils/constants';
import ArrowButton from '../../components/_atomic/ArrowButton/ArrowButton';
import AdminsScreenTable from './AdminsScreenTable/AdminsScrenTable';
import Button from '../../components/_atomic/Button/Button';
import './AdminsScreen.scss';
import CreateAdminModal from '../../components/_molecules/CreateAdminModal/CreateAdminModal';

class AdminsScreen extends Component {
  static propTypes = {
    getAllAdminsFull: PropTypes.func.isRequired,
    updateCreateAdminModal: PropTypes.func.isRequired,
    createModalStatus: PropTypes.bool.isRequired,
    sidebarStatus: PropTypes.bool,
    createAdminUser: PropTypes.func.isRequired,
    annulAdminError: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired,
    deleteAdmin: PropTypes.func.isRequired,
    hasMoreAdminsFull: PropTypes.number.isRequired,
    adminsFull: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    history: PropTypes
      .shape({
        push: PropTypes.func.isRequired,
      }).isRequired,
  };
  static defaultProps = {
    sidebarStatus: true,
  }
  state = {}
  componentWillMount() {}
  componentDidUpdate() {}
  navigateToUserLogs = (id) => {
    this.props.history.push(`${publicHash}/app/client/${id}/logs`);
  }
  navigateToUserProfile = (id) => {
    this.props.history.push(`${publicHash}/app/client/${id}/profile`);
  }
  navigateToAdminList = () => {
    this.props.history.push(`${publicHash}/app/admins`);
  }
  navigateToBack = () => {
    window.history.back();
  }
  changeCreateAdminModalStatus = () => {
    const { updateCreateAdminModal } = this.props;
    updateCreateAdminModal();
  }
  render() {
    const {
      sidebarStatus,
      createModalStatus,
      getAllAdminsFull,
      hasMoreAdminsFull,
      adminsFull,
      deleteAdmin,
      createAdminUser,
      annulAdminError,
      status,
      error,
    } = this.props;
    const clientsScreenClasses = classNames({
      screen: true,
      'admins-screen': true,
    });
    return (
      <div className={clientsScreenClasses}>
        <CreateAdminModal
          visible={createModalStatus}
          disableModal={this.changeCreateAdminModalStatus}
          getAllAdminsFull={getAllAdminsFull}
          createAdminUser={createAdminUser}
          annulAdminError={annulAdminError}
          status={status}
          error={error}
        />
        <div className="main-label-no-transform">
          <ArrowButton onClick={this.navigateToBack} padLeft={sidebarStatus ? 125 : 125} />
          <span>Admins</span>
        </div>
        <div className="add-admin-wrapper">
          <Button clickHandler={() => this.changeCreateAdminModalStatus()} label="Add admin" secondary />
        </div>
        {/* This is need to change in normal */}
        <AdminsScreenTable
          adminsFull={adminsFull}
          getAllAdminsFull={getAllAdminsFull}
          deleteAdmin={deleteAdmin}
          navigateToUserLogs={this.navigateToUserLogs}
          navigateToUserProfile={this.navigateToUserProfile}
          hasMoreAdminsFull={hasMoreAdminsFull}
          navigateToAdminList={this.navigateToAdminList}
        />
      </div>
    );
  }
}

export default AdminsScreen;



// WEBPACK FOOTER //
// ./src/containers/AdminsScreen/AdminsScreen.js